export default "__VITE_ASSET__De0LydJ1__"